import { AlertColor } from '@mui/material';
import { ADD_MESSAGE, AppContext, CLEAR_MESSAGE } from 'appContext';
import { useContext } from 'react';
export const snackbarType: Record<AlertColor, AlertColor> = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
} as const;
export interface SnackbarProps {
  message?: JSX.Element | string;
  type: AlertColor;
  onClick?: () => void;
}

export const useGlobalNotification = () => {
  const { dispatch } = useContext(AppContext);

  const displaySnackbar = ({ message, type, onClick }: SnackbarProps) => {
    dispatch({ type: CLEAR_MESSAGE });
    dispatch({
      type: ADD_MESSAGE,
      text: message || '',
      messageType: type,
      id: String(new Date().getTime()),
      onClick,
    });
  };

  return {
    displaySnackbar,
  };
};
